//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import storeMixins from '@/mixins/storeMixins'
import { mapState } from 'vuex'

export default {
  name: 'ShowInfo',
  mixins: [storeMixins],
  data: function () {
    return {
      packetId: this.$route.params.packet,
      touch: window.matchMedia('(any-pointer: coarse)').matches // true if device has touchscreen
    }
  },
  filters: {
    formatDate: function (timestamp) {
      return date.formatDate(timestamp, 'D.MM.YYYY')
    }
  },
  computed: {
    ...mapState('ui', [
      'footer',
      'lastSwipe'
    ]),
    packetPlayed: function () {
      if (this.userPacket.startedAt) { // If we already splayed the packet
        let message = 'Вы играли этот пакет '
        if (date.isSameDate(this.userPacket.startedAt, this.userPacket.lastPlayedAt, 'day')) {
          message += date.formatDate(this.userPacket.lastPlayedAt, 'D.MM.YYYY')
        } else {
          message += 'с ' + date.formatDate(this.userPacket.startedAt, 'D.MM.YYYY') + ' до ' + date.formatDate(this.userPacket.lastPlayedAt, 'D.MM.YYYY')
        }
        message += '.'
        return message
      }
      return false
    }
  }
}
